module.exports = __webpack_public_path__ + "static/img/pic-cnt-active-3.ee7a76c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/en/pic-cnt-active-3.png
// module id = bO1H
// module chunks = 0